import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { LoanTable } from "./LoanTable";
import { LoanForm } from "./LoanForm";

const thisMonth = () => new Date().toISOString().slice(0, 7);
const emptyForm = { user_id: "", principal: "", monthly_installment: "", start_month: thisMonth(), remarks: "" };

export const LoansPanel = () => {
  const [list, setList] = useState([]);
  const [emps, setEmps] = useState([]);
  const [form, setForm] = useState(emptyForm);

  const load = useCallback(() => api.get("/payroll/loans").then((r) => setList(r.data)), []);
  useEffect(() => {
    load();
    api.get("/employees").then((r) => setEmps(r.data.filter((e) => e.status === "active")));
  }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/payroll/loans", { ...form, principal: +form.principal, monthly_installment: +form.monthly_installment });
      toast.success("Advance recorded — recovery starts with the payroll run of the start month");
      setForm(emptyForm);
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  const del = async (id) => {
    try {
      await api.delete(`/payroll/loans/${id}`);
      toast.success("Advance deleted");
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="space-y-6" data-testid="loans-panel">
      <div className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
        <h3 className="font-heading font-bold">Loans & salary advances</h3>
        <p className="text-xs text-stone-500">Installments are auto-deducted from each payroll run (from the start month) until fully recovered.</p>
        <LoanForm emps={emps} form={form} setForm={setForm} onSubmit={add} />
      </div>

      <LoanTable list={list} onDelete={del} />
    </div>
  );
};
